// extracted by mini-css-extract-plugin
export var discard = "_30-3";
export var muiTooltipTooltip = "_30-5";
export var notificationBar = "_30-2";
export var saveButtonHoverSlotWrapper = "_30-4";
export var show = "_30-1";
export var spacer = "_30-0";